import axiosInstance from "api/axiosInstance";
import { roleAction } from "./role-slice";
import SAlert from "components/Alert";

// Get Roles
export const getRoles = () => (dispatch) => {
  dispatch(roleAction.setLoading(true));
  axiosInstance
    .get("/v1/roles")
    .then((response) => {
      if (response) {
        dispatch(roleAction.setError(null));
        dispatch(roleAction.setData(response?.data));
        dispatch(roleAction.setLoading(false));
      }
    })
    .catch((error) => {
      dispatch(roleAction.setLoading(false));
      console.log(error);
    });
};

// Get role by id
export const getByIdRole = (id) => (dispatch) => {
  dispatch(roleAction.setLoading(true));
  axiosInstance
    .get(`/v1/role/${id}`)
    .then((response) => {
      if (response) {
        dispatch(roleAction.setError(null));
        dispatch(roleAction.setRole(response?.data));
        dispatch(roleAction.setLoading(false));
      }
    })
    .catch((error) => {
      dispatch(roleAction.setLoading(false));
      console.log(error);
    });
};

// Update Role Permissions
export const updateRolePermission = (id, permission, status) => (dispatch) => {
  dispatch(
    roleAction.setPermissionChange({
      loading: true,
      error: null,
      data: null,
    })
  );
  axiosInstance
    .post(`/v1/role/${id}/update-permission`, { permission, status })
    .then((respnose) => {
      SAlert({
        title: "Success",
        text: "Role Permission successfully updated",
      });
      dispatch(
        roleAction.setPermissionChange({
          loading: false,
          error: null,
          data: respnose?.data,
        })
      );
    })
    .catch((error) => {
      dispatch(
        roleAction.setPermissionChange({
          loading: false,
          error: error?.response,
          data: null,
        })
      );
      console.log(error);
    });
};

// Get all permissions grouped by resource
export const getAllPermissionsGrouped = () => (dispatch) => {
  dispatch(roleAction.setLoading(true));
  axiosInstance
    .get("/v1/all-permissions")
    .then((response) => {
      if (response) {
        dispatch(roleAction.setGroupedPermissions(response?.data));
        dispatch(roleAction.setLoading(false));
      }
    })
    .catch((error) => {
      dispatch(roleAction.setLoading(false));
      console.log(error);
    });
};

// Create new role
export const createRole = (data, navigate) => (dispatch) => {
  dispatch(roleAction.setLoading(true));
  axiosInstance
    .post("/v1/roles-manage", data)
    .then((response) => {
      SAlert({
        title: "Success",
        text: "Role created successfully",
      });
      dispatch(roleAction.setLoading(false));
      navigate("/roles");
    })
    .catch((error) => {
      dispatch(roleAction.setLoading(false));
      const errorMessage =
        error?.response?.data?.message || "Failed to create role";
      console.log(error);
    });
};

// Update role
export const updateRole = (id, data, navigate) => (dispatch) => {
  dispatch(roleAction.setLoading(true));
  axiosInstance
    .put(`/v1/roles-manage/${id}`, data)
    .then((response) => {
      SAlert({
        title: "Success",
        text: "Role updated successfully",
      });
      dispatch(roleAction.setLoading(false));
      navigate("/roles");
    })
    .catch((error) => {
      dispatch(roleAction.setLoading(false));
      const errorMessage =
        error?.response?.data?.message || "Failed to update role";
      console.log(error);
    });
};

// Delete role
export const deleteRole = (id) => (dispatch) => {
  dispatch(roleAction.setLoading(true));
  axiosInstance
    .delete(`/v1/roles-manage/${id}`)
    .then((response) => {
      SAlert({
        title: "Success",
        text: "Role deleted successfully",
      });
      dispatch(getRoles());
    })
    .catch((error) => {
      dispatch(roleAction.setLoading(false));
      const errorMessage =
        error?.response?.data?.message || "Failed to delete role";
      console.log(error);
    });
};
